import PropTypes from 'prop-types';

import headerBorderLeft from '../../assets/Images/headerBorder.png';
import headerBorderRight from '../../assets/Images/headerBorderRight.png';

const DesignedHeader = ({title, description}) => {
  return (
    <div className={'text-center text-primary-900'}>
      <h1 className={'italianno-regular text-primary-900 lg:text-7xl text-5xl flex items-center gap-0 lg:gap-2 justify-center flex-wrap'}>
        <img
          src={headerBorderLeft}
          alt={'left-border'}
          className={'h-20 w-auto max-w-[250px] hidden lg:block'}
        />
        <span className={'m-0'}>{title}</span>
        <img
          src={headerBorderRight}
          alt={'right-border'}
          className={'h-20 w-auto max-w-[250px] hidden lg:block'}
        />
      </h1>
      <p className={'baskervville-regular text-primary-900 lg:text-lg text-sm mb-3'}>
        {description}
      </p>
    </div>
  );
};

DesignedHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default DesignedHeader;
